import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
export function HoursLocation() {
  return <section id="location" className="py-24 bg-white" data-id="element-173" data-mp="36px2sd3y0gwr">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174" data-mp="32p3c5bz48o06">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-175" data-mp="32n8rlyrraxwm">
          {/* Info Side */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-176" data-mp="3ugsqay1d8py7">
            <h2 className="font-serif text-4xl text-charcoal mb-10" data-id="element-177" data-mp="3gfyiohm56t0l">
              Visit Us
            </h2>

            <div className="space-y-8" data-id="element-178" data-mp="2a1qvfifmzaes">
              <div className="flex items-start" data-id="element-179" data-mp="251unj83tiyty">
                <MapPin className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-180" data-mp="25132usbrelig" />
                <div data-id="element-181" data-mp="2n4hgfs8dgyzl">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-182" data-mp="2r7ni0mkji1zq">
                    Location
                  </h4>
                  <p className="text-gray-600 text-lg" data-id="element-183" data-mp="2d7mfz3sjgoio">
                    207 Broadway St.
                    <br data-id="element-184" data-mp="2i5o07s1patvq" />
                    Paducah, KY 42001
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-185" data-mp="23g8fasoupiny">
                <Clock className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-186" data-mp="289bbz9oxd88d" />
                <div data-id="element-187" data-mp="1ujhgi8iwzppo">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-188" data-mp="1zgr5xo6b01di">
                    Hours
                  </h4>
                  <ul className="text-gray-600 text-lg space-y-1" data-id="element-189" data-mp="1kks06k6o2dbj">
                    <li className="flex justify-between w-56" data-id="element-190" data-mp="1pia94akoosjj">
                      <span data-id="element-191" data-mp="1pko3eh7ji0q1">Mon - Thu:</span> <span data-id="element-192" data-mp="16dyjngtaroht">4pm - 9pm</span>
                    </li>
                    <li className="flex justify-between w-56" data-id="element-193" data-mp="16f9l39z9sk5r">
                      <span data-id="element-194" data-mp="11m6zbo0qif04">Fri - Sat:</span> <span data-id="element-195" data-mp="11lnjccuna0oq">4pm - 10pm</span>
                    </li>
                    <li className="flex justify-between w-56 text-warm-brown font-medium" data-id="element-196" data-mp="wnc9i24cnq6i">
                      <span data-id="element-197" data-mp="rpkdox0l3jx1">Sunday:</span> <span data-id="element-198" data-mp="rqdelhcv3f79">Closed</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start" data-id="element-199" data-mp="1pc191wprbng5">
                <Phone className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-200" data-mp="1kdgae1q5lbtt" />
                <div data-id="element-201" data-mp="1fcs8um4atclc">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-202" data-mp="1fgg5hu51if4a">
                    Contact
                  </h4>
                  <p className="text-gray-600 text-lg" data-id="element-203" data-mp="40j1qzsjlqn0">(270) 933-1707</p>
                  <p className="text-gray-600 text-lg mt-1" data-id="element-204" data-mp="3v60y00i5mbyu">
                    sun_cheah@yahoo.com
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="h-full min-h-[400px] relative rounded-sm overflow-hidden shadow-lg border border-gray-200" data-id="element-205" data-mp="2fnuzma4lo2t6">
            <iframe title="Map to Freddie Cheah, 207 Broadway St, Paducah, KY" src="https://www.google.com/maps?q=207%20Broadway%20St%2C%20Paducah%2C%20KY%2042001&output=embed" className="absolute inset-0 w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-206" data-mp="33ce7wpnngfl9" />
            <a href="https://www.google.com/maps/dir/?api=1&destination=207+Broadway+St+Paducah+KY+42001" target="_blank" rel="noopener noreferrer" className="absolute bottom-4 right-4 bg-charcoal text-cream px-4 py-2 text-xs font-medium tracking-wider uppercase shadow-lg hover:bg-warm-brown transition-colors" data-id="element-207" data-mp="34el18mvvgwoz">
              Get Directions
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}